import get from 'lodash/get';
import error from 'aurora-utils/error';
import * as types from './constants';

const initialState = {
  loading: false,
  wallet: null,
  transactions: null,
  transactionDetails: null,
  error: null,
  walletError: null,
  // balance: null,
};

export default function walletReducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.FETCH_WALLET:
      return {
        ...state,
        query: get(action.payload, 'query'),
        loading: true,
      };
    case types.FETCH_WALLET_SUCCESS:
      return {
        ...state,
        loading: false,
        wallet: get(action.payload, 'wallet'),
        error,
      };
    case types.FETCH_WALLET_ERROR:
      return {
        ...state,
        loading: false,
        wallet: null,
        error: get(action.payload, 'error'),
        walletError: get(action.payload, 'error'),
      };
    case types.FETCH_TRANSACTIONS:
      return {
        ...state,
        loading: true,
        query: get(action.payload, 'query'),
        transactions: null,
      };
    case types.FETCH_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        transactions: get(action.payload, 'transactions'),
        error,
      };
    case types.FETCH_TRANSACTIONS_ERROR:
      return {
        ...state,
        loading: false,
        transactions: null,
        error: get(action.payload, 'error'),
      };
    case types.FETCH_WALLET_AND_TRANSACTIONS:
      return {
        ...state,
        loading: true,
        query: get(action.payload, 'query'),
      };
    case types.FETCH_WALLET_AND_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        wallet: get(action.payload, 'wallet'),
        transactions: get(action.payload, 'transactions'),
        error,
      };
    case types.FETCH_WALLET_AND_TRANSACTIONS_ERROR:
      return {
        ...state,
        loading: false,
        wallet: null,
        transactions: null,
        error: get(action.payload, 'error'),
      };

    default:
      return state;
  }
}
